import React from "react";
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  "@keyframes lineSweep": {
    "0%, 100%": { transform: "translateX(0)", opacity: 1 },
    "50%": { transform: theme.direction === "rtl" ? "translateX(-52px)" : "translateX(52px)", opacity: .55 },
  },
  "@keyframes eyebrowGlow": {
    "0%, 100%": { textShadow: "0 0 0 rgba(22,139,255,0)" },
    "50%": { textShadow: "0 0 18px rgba(22,139,255,.34)" },
  },
  root: {
    position: "relative",
    width: "100%",
    marginBottom: 36,
    paddingBottom: 18,
    textAlign: theme.direction === "rtl" ? "right" : "left",
  },
  eyebrow: {
    color: "var(--accent)",
    fontSize: 10,
    fontWeight: 850,
    marginBottom: 8,
    letterSpacing: theme.direction === "rtl" ? 0 : ".14em",
    textTransform: theme.direction === "rtl" ? "none" : "uppercase",
    animation: "$eyebrowGlow 4.6s ease-in-out infinite",
  },
  title: {
    color: "var(--text-primary)",
    fontWeight: 900,
    fontSize: "clamp(2rem, 4vw, 3.2rem)",
    lineHeight: 1.2,
    letterSpacing: theme.direction === "rtl" ? 0 : "-.035em",
    textAlign: theme.direction === "rtl" ? "right" : "left",
    overflowWrap: "break-word",
  },
  line: {
    position: "relative",
    width: 110,
    height: 4,
    marginTop: 14,
    borderRadius: 999,
    background: "var(--accent-soft-2)",
    marginLeft: theme.direction === "rtl" ? "auto" : 0,
    marginRight: theme.direction === "rtl" ? 0 : "auto",
    overflow: "hidden",
    "&::after": {
      content: '\"\"',
      position: "absolute",
      top: 0,
      bottom: 0,
      width: 44,
      left: theme.direction === "rtl" ? "auto" : 0,
      right: theme.direction === "rtl" ? 0 : "auto",
      borderRadius: 999,
      background: "linear-gradient(90deg,var(--accent),var(--accent-2))",
      boxShadow: "0 0 18px rgba(22,139,255,.38)",
      animation: "$lineSweep 3.6s ease-in-out infinite",
    },
  },
}));

export default function Title({ title, eyebrow }) {
  const classes = useStyles();

  return (
    <header className={classes.root}>
      {eyebrow ? <div className={classes.eyebrow}>{eyebrow}</div> : null}
      <Typography component="h1" className={classes.title}>{title}</Typography>
      <div className={classes.line} />
    </header>
  );
}
